module.exports = function () {

    let module = {};

    module.environment = process.env.NODE_ENV;
    module.isLive = (module.environment == 'production') ? true : false;
    module.isStaging = (module.environment == 'staging') ? true : false;
    module.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;


    module.log = function (message) {
        if (!module.isStaging && !module.isLive)
            return console.log(message);
    };

    // Only include Bootstrap modules required
    module.initBootstrap = function () {
        require('bootstrap/js/dist/index');
        require('bootstrap/js/dist/alert');
        require('bootstrap/js/dist/button'); // required for auto complete library
        //require('bootstrap/js/dist/carousel');
        require('bootstrap/js/dist/collapse');
        require('bootstrap/js/dist/dropdown');
        require('bootstrap/js/dist/modal');
        // require('bootstrap/js/dist/popover');
        // require('bootstrap/js/dist/scrollspy');
        require('bootstrap/js/dist/tab');
        // require('bootstrap/js/dist/tooltip');
        // require('bootstrap/js/dist/util');
    };

    // module.initDatepicker = function () {
    //     require('jquery-ui/ui/keycode');
    //     require('jquery-ui/ui/widgets/datepicker');
    //
    //     $('.datepicker').datepicker({
    //         dateFormat: "d MM yy",
    //         changeMonth: true,
    //         changeYear: true,
    //         maxDate: "-18y"
    //     });
    // }


    module.initLazyLoad = function () {
        const lasysizes = require('lazysizes/lazysizes');
        lazySizes.cfg.lazyClass = 'lazy';
    };

    module.initRrssb = function () {
        require('rrssb');
    };

    module.initPopups = function () {
        if ($('#popupModal').length) {
            let id = $('#popupModal').data('id');
            let popupShown = localStorage.getItem('popup-' + id + '-shown');
            let expirationDate = localStorage.getItem('popup-' + id + '-expiration');

            // Check if the popup has been shown and if the expiration date has passed
            if (!popupShown || Date.now() > parseInt(expirationDate)) {
                let delay = parseInt($('#popupModal').data('delay') + '000');
                let next_display_time = parseInt($('#popupModal').data('next-display-time'));
                const expirationTime = Date.now() + (next_display_time ? next_display_time : 7) * 24 * 60 * 60 * 1000; // Current time + 7 days in milliseconds

                setTimeout(function () {
                    $('#popupModal').modal('show');
                    localStorage.setItem('popup-' + id + '-shown', 'true');
                    localStorage.setItem('popup-' + id + '-expiration', expirationTime.toString());
                }, delay ? delay : 2000);
            }
        }
    };

    module.keepTokenAlive = function (){

        // To override the default mins, add a <body> data tag value for 'token_minutes'
        let keepAlive = $('body').data('token-minutes');

        setInterval(keepTokenAlive, 1000 * 60 * (keepAlive ? keepAlive : 3)); // every 3 or x mins

        function keepTokenAlive() {
            $.ajax({
                url: '/keep-token-alive', //https://stackoverflow.com/q/31449434/470749
                method: 'post',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).then(function (result) {
                console.log(new Date() + ' ' + result + ' ' + $('meta[name="csrf-token"]').attr('content'));
            });
        }
    }

    module.initTooltips = function () {

        $('[data-toggle="tooltip"]').tooltip({
            trigger: 'hover focus',
            placement: 'bottom',
            container: 'body'
        });
    };


    module.initStickyEl = function () {

        // Get sticky el's
        let el = $('.is-sticky');

        sessionStorage.setItem('height', $('header').height());

        // When the user scrolls the page, execute myFunction
        window.onscroll = function () {
            module.addStickyClass();
        };

        module.addStickyClass();
    };

    module.addStickyClass = function () {

        let body = $('body');

        let height = sessionStorage.getItem('height') ? sessionStorage.getItem('height') : $('header').height();

        if (window.pageYOffset >= (height / 2) && window.pageYOffset < height) {
            body.addClass("before-stuck").removeClass("stuck").css('padding-top', '0');
        } else if (window.pageYOffset == 0) {
            body.removeClass("stuck").removeClass("before-stuck").css('padding-top', '0');
        } else if (window.pageYOffset > height) {
            body.addClass("stuck").removeClass("before-stuck").css('padding-top', height + 'px');

        }

    };


    // module.navDropdownHover = function () {
    //
    //     const $dropdown = $(".dropdown");
    //     const $dropdownToggle = $(".dropdown-toggle");
    //     const $dropdownMenu = $(".dropdown-menu");
    //     const showClass = "show";
    //
    //     $(window).on("load resize", function() {
    //         if (this.matchMedia("(min-width: 768px)").matches) {
    //             $dropdown.hover(
    //                 function() {
    //                     const $this = $(this);
    //                     $this.addClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "true");
    //                     $this.find($dropdownMenu).addClass(showClass);
    //                 },
    //                 function() {
    //                     const $this = $(this);
    //                     $this.removeClass(showClass);
    //                     $this.find($dropdownToggle).attr("aria-expanded", "false");
    //                     $this.find($dropdownMenu).removeClass(showClass);
    //                 }
    //             );
    //         } else {
    //             $dropdown.off("mouseenter mouseleave");
    //         }
    //     });
    // };


    module.announcementBarDismiss = function () {
        if($('#announcement-dismiss').length) {
            $('#announcement-dismiss').click(function () {
                $.get("/announcement-dismiss", function () {
                    console.log("Announcement bar dismissed");
                    $('#announcement-dismiss').fadeOut(300);
                })
            });
        }
    };

    module.initSpotlightJs = function () {
        if ($('.spotlight').length)
            require('spotlight.js');
    };


    module.initTingleModalJs = function () {

        const Tingle = require('tingle.js');

        var modal = new Tingle.modal({
            stickyFooter: false,
            footer: false,
            closeMethods: ['overlay', 'button', 'escape'],
            cssClass: ['custom-class-1', 'custom-class-2'],
        });

        $('.md-trigger').click(function (event) {
            let id = $(this).data('id');
            modal.setContent($('#' + id).html());
            modal.open();
        });
    };

    module.initLightbox = function () {
        require('ekko-lightbox');
        $(document).on('click', '[data-toggle="lightbox"]', function (event) {
            event.preventDefault();
            $(this).ekkoLightbox({
                alwaysShowClose: true,
                leftArrow: '<i class="fa fa-chevron-left left"></i>',
                rightArrow: '<i class="fa fa-chevron-right right"></i>'
            });
        });
    };

    module.initMobileMenu = function () {
        require('../plugins/jquery-simple-mobile-menu');
        $(".mobile_menu").simpleMobileMenu();
        $('#sm_menu_ham').addClass('icon').prependTo('.mobile-icons');
    };

    module.initSlickCarousel = function () {
        require('@accessible360/accessible-slick');

        $('.slick.testimonials').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            cssEase: 'linear',
        });

        $('.slick.single').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            fade: true,
            arrows: true,
            dots: false,
            cssEase: 'linear',
            prevArrow: $('.block-prev'),
            nextArrow: $('.block-next'),
        });

        $('.slick.slides').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            arrows: true,
            dots: false,
        });

        $('.slick.cards').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            centerMode: true,
            centerPadding: '11em',
            draggable: true,
            arrows: true,
            dots: false,
            /*prevArrow: $('.service-prev'),
            nextArrow: $('.service-next'),*/

            responsive: [
                {
                    breakpoint: 1350,
                    settings: {
                        slidesToShow: 1,
                        centerPadding: '50px',
                    }
                },

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                    }
                },

                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },

                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        centerMode: false,
                    }
                },
            ]
        });

        $('.slick.testimonials-slides').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            arrows: false,
            cssEase: 'linear',
            dots: false,

            responsive: [
                {
                    breakpoint: 1265, // sm
                    settings: {
                        slidesToShow: 2
                    }
                },

                {
                    breakpoint: 992, // sm
                    settings: {
                        slidesToShow: 1
                    }
                },

            ]


        });

        $('.slick-carousel.projects').slick({
            infinite: false,
            slidesToShow: 2.5,
            centerPadding: '150px',
            slidesToScroll: 1,
            //adaptiveHeight: false,
            arrows: true,

            responsive: [

                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 2.5,
                        centerPadding: '150px'
                    }
                },
                {
                    breakpoint: 1000,
                    settings: {
                        slidesToShow: 2.4,
                        centerPadding: '100px'
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1.5,
                        centerPadding: '50px'
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1.1,
                        centerPadding: '10px',
                    }
                }
            ],

        });

    };


        module.scrollToAnchor = function () {
        $('a[href^=\\#scroll-]').on('click', function (e) {
            e.preventDefault();

            let collapseId = $(this).attr('href').replace('scroll-', '');

            console.log(collapseId);

            module.scrollToElement(collapseId);
        });
    };


    module.detectUrlScrollHash = function () {
        if (window.location.hash.indexOf('scroll-') == 1) {

            let el = window.location.hash.replace('scroll-', '');

            console.log('Attempting automatic scroll to ' + el);

            this.scrollToElement(el);
        }
    };

    module.scrollToElement = function (element) {
        console.log('Attempt to scroll to el ' + element);
        $('html,body').animate({scrollTop: $(element).offset().top - 100}, 'slow', function () {
            if ($(element).length && $(element).next().hasClass('collapse')) {
                $(element).next().collapse('show');
            }
        });
    };

    module.scrollToAccordionItem = function () {

        $('.accordion').on('shown.bs.collapse', function (event) {
            let getHeaderEl = $('#' + event.target.id).prev('.card-header').attr('id');

            if (getHeaderEl)
                module.scrollToElement('#' + getHeaderEl);
        });

    };

    module.initWowJs = function () {
        const {WOW} = require('wowjs');
        new WOW({
            mobile: false,
        }).init();
    };


    module.convertCryptedEmails = function () {

        $('.cryptedmail').each(function () {

            let
                el = $(this).find('span'),
                e = el.data('name') + '@' + el.data('domain') + '.' + el.data('tld');

            $(this).attr('href', 'mailto:' + e).removeClass('cryptedmail').find('span');

            if ((typeof el.data('show-value') == 'undefined') || el.data('show-value'))
                el.html(el.data('value') ? el.data('value') : e);
        });
    };

    module.bgText = function () {

        $(document).ready(function () {
            const $bgText = $('.bg-text');

            $(window).on('scroll', function () {
                const scrollTop = $(window).scrollTop();
                const offsetTop = $bgText.offset().top;
                const windowHeight = $(window).height();

                // Distance from the center of viewport to the element
                const distance = offsetTop - scrollTop;
                const visibleRange = windowHeight; // scale affects within full screen height

                if (distance < visibleRange && distance > -$bgText.height()) {
                    // Normalize scale from 0.9 to 1.2 based on scroll
                    let scale = 0.9 + (1 - distance / visibleRange) * 0.3;

                    // Clamp the value (optional)
                    scale = Math.min(Math.max(scale, 0.9), 1.5);

                    $bgText.css('transform', `scale(${scale})`);
                }
            });
        });


    };


    module.wrapTables = function () {
        document.querySelectorAll("table").forEach(function (table) {
            if (!table.parentElement.classList.contains("table-responsive")) {
                const wrapper = document.createElement("div");
                wrapper.className = "table-responsive";
                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });
    };

    return module;



};

